// updates the shoppingcart counter on order pages (legacy)
// see README.md for more information
import React from 'react';
import Cookies from 'js-cookie';
import h from 'hyperscript';
import NumberInput from 'components/molecules/number-input/react/NumberInput';
import { t } from 'javascripts/utils/withTranslation';
import { createRoot } from 'react-dom/client';
import {
  updateStickyLinkNumber,
  toggleStickyLink,
} from '../../components/atoms/sticky-link/sticky-link';

function updateCartAmount(cartAmount, $trigger) {
  const $stickyLink = document.querySelector('.sticky-link');

  if ($stickyLink) {
    toggleStickyLink($stickyLink, cartAmount > 0);
    updateStickyLinkNumber($stickyLink, cartAmount);
  }

  if ($trigger) {
    const href =
      $trigger.getAttribute('data-cart-url') ||
      $stickyLink?.getAttribute('href');
    const succesMessage =
      $trigger.getAttribute('data-success-message') ||
      t('Artikel ist im Warenkorb. Auswahl ändern?');

    // change appearance of icon
    const $iconUse = $trigger.querySelector('.icon use');
    if ($iconUse) {
      $iconUse.setAttribute('xlink:href', '#icon-bw-cart-solid');
    }
    if (href) {
      // change the button to a link to the shopping cart
      const link = document.createElement('a');
      link.className = $trigger.className;
      link.innerHTML = $trigger.innerHTML;
      link.setAttribute('href', href);
      $trigger.replaceWith(link);

      // change text to success message
      const $text = link.querySelector('.icon-link__text, .link-list__text');
      if ($text) {
        $text.innerHTML = succesMessage;
      }
      link.focus();
    }
  }
}

function getCartAmount(url, $trigger) {
  if (url) {
    const Http = new XMLHttpRequest();
    Http.open('GET', url);
    Http.send();
    Http.onreadystatechange = () => {
      if (Http.readyState === 4 && Http.status === 200) {
        const cartAmount = parseInt(Http.responseText.trim(), 10);
        updateCartAmount(cartAmount, $trigger);
      }
    };
  }
}

export async function updateItemAmount(url, queryParam, amount) {
  if (url) {
    try {
      const response = await fetch(`${url}&${queryParam}=${amount}`);
      if (!response.ok) {
        return -1;
      }

      const json = await response.json();
      return json.toString();
    } catch (error) {
      console.error(error.message);
      return -1;
    }
  }
  return -1;
}

function addToShoppingCart(event, $trigger) {
  event.preventDefault();
  const href = $trigger.getAttribute('data-href');
  if (href) {
    getCartAmount(href, $trigger);
  }
}

export const initAddToCartButtons = () => {
  const neededCookie = Cookies.get('bawu-consent') || null;

  if (neededCookie || neededCookie === 'accept') {
    document.querySelectorAll('.js-add-to-shopping-cart').forEach(($link) => {
      // change the link to a button and add the href as data-href
      $link.classList.remove('disabled');
      $link.querySelector('.icon-link__info')?.remove();
      const button = document.createElement('button');
      button.className = $link.className;
      button.innerHTML = $link.innerHTML;
      button.type = 'button';
      button.setAttribute('data-href', $link.href);
      const successMessage = $link.getAttribute('data-success-message');
      const cartUrl = $link.getAttribute('data-cart-url');
      if (successMessage) {
        button.setAttribute('data-success-message', successMessage);
      }
      if (cartUrl) {
        button.setAttribute('data-cart-url', cartUrl);
      }
      button.addEventListener('click', (event) =>
        addToShoppingCart(event, button)
      );

      $link.replaceWith(button);
      button
        .querySelector('.icon-link__text')
        ?.setAttribute('aria-live', 'polite');
    });
  } else {
    document.querySelectorAll('.js-add-to-shopping-cart').forEach(($link) => {
      const $cookieInfo = h(
        'span.icon-link__info',
        t('Bitte akzeptieren Sie die technisch notwendigen Cookies')
      );

      $link.addEventListener('click', (event) => event.preventDefault());
      $link.classList.add('disabled');
      $link.appendChild($cookieInfo);
    });
  }
};

export const initEditCartInputs = () => {
  document.querySelectorAll('.js-edit-cart-input').forEach(($numberInput) => {
    const { url, queryParam } =
      $numberInput.querySelector('input')?.dataset || {};

    if (!url) {
      console.warn('No URL provided for .js-edit-cart-input', $numberInput);
      return;
    }

    if (url && !queryParam) {
      console.warn(
        'No data-query-param provided for .js-edit-cart-input, using default rsmbwpublications[ammount].',
        $numberInput
      );
    }

    const domAttributes = $numberInput.querySelector(
      '.number-input__input'
    )?.attributes;
    const inputProps = Array.from(domAttributes || []).reduce((acc, a) => {
      const newAcc = { ...acc };
      newAcc[a.name] = a.value;
      return newAcc;
    }, {});
    $numberInput.setAttribute('aria-live', 'polite');
    const root = createRoot($numberInput);
    root.render(
      <NumberInput
        url={url}
        queryParam={queryParam || 'rsmbwpublications[ammount]'}
        inputProps={inputProps}
      />
    );
  });
};

initAddToCartButtons();
initEditCartInputs();

export default initAddToCartButtons;
